// Professional Subscription Success Modal
import { CheckCircle, X, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PLAN_WELCOME = {
  starter: {
    title: 'Welcome to Starter',
    subtitle: 'Your subscription is now active',
    features: ['Add up to 3 properties', 'Unlimited tenant reports', 'Unlimited lookups', 'Full platform access']
  },
  professional: {
    title: 'Welcome to Professional',
    subtitle: 'Your subscription is now active',
    features: ['Add up to 10 properties', 'Priority Support', 'Team Accounts', 'Advanced Analytics', 'Everything in Starter']
  },
  enterprise: {
    title: 'Welcome to Enterprise',
    subtitle: 'Your subscription is now active',
    features: ['Unlimited properties', 'API Access', 'Bulk Operations', 'Priority Support', 'Everything in Professional']
  }
};

export default function SubscriptionSuccessModal({ isOpen, plan, onClose }) {
  if (!isOpen || !plan) return null;

  const welcome = PLAN_WELCOME[plan] || PLAN_WELCOME.starter;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden" data-testid="subscription-success-modal">
        {/* Success Icon Header */}
        <div className="relative bg-gradient-to-br from-teal-500 to-teal-700 px-8 py-10 text-center overflow-hidden">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(circle at 20% 20%, white 1px, transparent 1px), radial-gradient(circle at 70% 60%, white 1px, transparent 1px)', backgroundSize: '28px 28px' }} />
          <div className="relative w-20 h-20 mx-auto mb-4">
            <span className="absolute inset-0 rounded-full bg-white/30 animate-ping" />
            <div className="relative w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-lg">
              <CheckCircle className="w-11 h-11 text-teal-600" />
            </div>
          </div>
          <h2 className="relative text-2xl font-bold text-white tracking-tight">{welcome.title}</h2>
          <p className="relative text-teal-50 text-sm mt-1">{welcome.subtitle}</p>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="flex items-center gap-2 mb-3 px-3 py-2 rounded-lg bg-emerald-50 border border-emerald-100">
            <CheckCircle className="w-4 h-4 text-emerald-600 shrink-0" />
            <p className="text-xs text-emerald-800">Payment successful — a receipt has been emailed to you.</p>
          </div>
          <p className="text-sm font-semibold text-slate-800 mb-3">What you've unlocked</p>
          <ul className="space-y-2.5 mb-6">
            {welcome.features.map((feature, idx) => (
              <li key={idx} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <CheckCircle className="w-3.5 h-3.5 text-teal-600" />
                </div>
                <span className="text-sm text-slate-700">{feature}</span>
              </li>
            ))}
          </ul>

          <Button
            onClick={onClose}
            className="w-full h-11 bg-teal-600 hover:bg-teal-700 text-white font-semibold text-sm rounded-lg"
            data-testid="success-get-started-btn"
          >
            Start using {welcome.title.replace('Welcome to ', '')}
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
}
